import 'reset-css'
import 'leaflet/dist/leaflet.css'
import '@/assets/stylesheets/main.scss'
import '@/assets/icons'

import Vue from 'vue'
import Meta from 'vue-meta'
import SvgIcon from 'vue-svgicon'
import VueFullPage from 'vue-fullpage.js'
import VuePackeryPlugin from 'vue-packery-plugin'
import VueMq from 'vue-mq'
import vbclass from 'vue-body-class'

import App from './App.vue'
import router from './router'
import store from './store'
import api from './api'
import './filters/filters'


const firstTime = true

Vue.config.productionTip = false
Vue.prototype.$api = api
Vue.use( vbclass, router )
Vue.use(Meta)
Vue.use(SvgIcon)
Vue.use(VueFullPage)
Vue.use(VuePackeryPlugin)
Vue.use(VueMq, {
  breakpoints: {
    sm: 640,
    md: 1250,
    lg: Infinity,
  }
})

Vue.filter('trimHash', (value) => {
  return value.split('~')[0]
})

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

export { firstTime }
